<template>
  <div class="home">
    <transition-group name="slide-up" tag="div" appear>
      <div key="einsatz" class="einsatzdashboard"  @click="$router.push('/einsatz/'+this.routeParams)">
        <div class="line1">
          <div>
            <h2 class="aktuellerEinsatz">Aktueller Einsatz</h2>
            <p class="einsatzText">Holen Sie sich Infos für Ihren Einsatz</p>
            <button class="einsatzdashboardButtonResponsive"><span>Zum Einsatzdashboard</span><span class="fa">&#xf105;</span></button>
          </div>
          <div>
            <img class="feuerwehrmann" src="@/assets/Icons/Feuerwehrmann.png">
          </div>
        </div>
        <div class="line2">
          <button class="einsatzdashboardButton"><span>Zum Einsatzdashboard</span><span class="fa">&#xf105;</span></button>
        </div>
      </div>
      <div key="schnell1" class="Schnellkacheln">
        <Schnellkachel :id="'1'" :navigation="this.kachel1.navigation" :selected="this.kachel1.navigation == undefined?false:true" :imgSrc="this.kachel1.imgSrc" :title="this.kachel1.name" :text="this.kachel1.beschreibung" :iconSrc="this.kachel1.iconSrc" @kachelHinzufügen="this.kachelHinzufuegen" @kachelEntfernen="this.kachelEntfernen"/>
        <Schnellkachel :id="'2'" :navigation="this.kachel2.navigation" :selected="this.kachel2.navigation == undefined?false:true" :imgSrc="this.kachel2.imgSrc" :title="this.kachel2.name" :text="this.kachel2.beschreibung" :iconSrc="this.kachel2.iconSrc" @kachelHinzufügen="this.kachelHinzufuegen" @kachelEntfernen="this.kachelEntfernen"/>
      </div>
      <div key="schnell2" class="Schnellkacheln">
        <Schnellkachel :id="'3'" :navigation="this.kachel3.navigation" :selected="this.kachel3.navigation == undefined?false:true" :imgSrc="this.kachel3.imgSrc" :title="this.kachel3.name" :text="this.kachel3.beschreibung" :iconSrc="this.kachel3.iconSrc" @kachelHinzufügen="this.kachelHinzufuegen" @kachelEntfernen="this.kachelEntfernen"/>
        <Schnellkachel :id="'4'" :navigation="this.kachel4.navigation" :selected="this.kachel4.navigation == undefined?false:true" :imgSrc="this.kachel4.imgSrc" :title="this.kachel4.name" :text="this.kachel4.beschreibung" :iconSrc="this.kachel4.iconSrc" @kachelHinzufügen="this.kachelHinzufuegen" @kachelEntfernen="this.kachelEntfernen"/>
      </div>
      <div key="sonstiges" class="Sonstiges" v-if="false">
        <div class="sonstigeCont" @click="$router.push('/lern-hub/'+this.routeParams)">
          <div class="sonstigeImageCont">
            <img class="sonstigeImage" src="@/assets/Icons/lern-hub.svg">
          </div>
          <div class="sonstigeTextCont">
            <h2 class="sonstigeText">Lern-Hub</h2>
          </div>
        </div>
        <div class="sonstigeCont" @click="$router.push('/mehr/'+this.routeParams)">
          <div class="sonstigeImageCont">
            <img class="sonstigeImage" src="@/assets/Icons/Sprechblase.png">
          </div>
          <div class="sonstigeTextCont">
            <h2 class="sonstigeText">Mehr</h2>
          </div>
        </div>
      </div>
    </transition-group>
    <br><br>
  </div>
</template>
  
<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Schnellkachel from '@/components/Home/Schnellkachel.vue';
import Menu from '@/components/Home/Menu.vue';
import { useRouter } from 'vue-router';
import {Benutzer} from '@/backend_controller/benutzer.js';
import FooterNavigation from '@/components/Home/FooterNavigation.vue';

export default {
    name: 'home',
    components: {
      Schnellkachel,
      Menu,
      FooterNavigation
    },
    data() {
      return{
        routeParams: String,
        menuActive: false,
        fullscreen: false,
        ip: '',
        logedin: false,
        aktiveKacheln: [
        ],
        kachel1: {},
        kachel2: {},
        kachel3: {},
        kachel4: {}
      }
    },
    methods:{
      getAktiveKachel(id){
        var kachel = localStorage.getItem("kachel"+id);
        if(kachel != null){
          return JSON.parse(kachel);
        } else{
          return false;
        }
      },
      getAktiveKacheln(){
        var aktiveKacheln = [];
        this.kachel1 = {};
        this.kachel2 = {};
        this.kachel3 = {};
        this.kachel4 = {};
        for(var i = 1; i <= 4; i++){
          if(localStorage.getItem("kachel"+i) != null){
            aktiveKacheln.push({id: i, data: JSON.parse(localStorage.getItem("kachel"+i))});
            if(i == 1){
              this.kachel1 = JSON.parse(localStorage.getItem("kachel"+i));
            } else if(i == 2){
              this.kachel2 = JSON.parse(localStorage.getItem("kachel"+i));
              console.log(this.kachel2);
            } else if(i == 3){
              this.kachel3 = JSON.parse(localStorage.getItem("kachel"+i));
            } else if(i == 4){
              this.kachel4 = JSON.parse(localStorage.getItem("kachel"+i));
            }
          }
        }
        this.aktiveKacheln = aktiveKacheln;
      },
      kachelHinzufuegen(kachelObjekt){
        console.log("Hinzufügen", kachelObjekt);
        localStorage.setItem("kachel"+kachelObjekt.id, JSON.stringify(kachelObjekt.data));
        this.getAktiveKacheln();
      },
      kachelEntfernen(kachelID){
        console.log("Entfernen", kachelID);
        localStorage.removeItem("kachel"+kachelID);
        this.getAktiveKacheln();
      },
      async getBenutzerDefaults() {
        console.log("Defaults")
          try{
              var konvKey = this.$route.params.id.replace(":","");
              const response = await axios.get(
                  'https://feuerwehr-server.org:5000/defaultwerte',
                  { params: { konvKey: konvKey } }
              );
              //return response.data;
              console.log(response.data);
              if(response.data == {} || response.data == null || response.data == ""){
                response.data = await this.createDefaults();
              }
              delete response.data.email;

              for(var [key,value] of Object.entries(response.data)){
                  if(value == 1){
                      response.data[key] = true;
                  } else{
                      response.data[key] = false;
                  }
                  localStorage.setItem(key,value);
              }
          } catch (err){
              console.log(err);
          }
      },
      async createDefaults() {
        var benutzer = await this.getBenutzer(this.$route.params.id.replace(":", ""));
        console.log(benutzer)
        try {
            if(benutzer.email == null || benutzer.email == undefined || benutzer.email == ""){
              return false;
            }
            const response = await axios.post(`https://feuerwehr-server.org:5000/addDefaultwerte?email=${benutzer.email}`);
            console.log(response.data);
            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
      },
      async getBenutzer(konvKey) {
        try{
          if(this.$route.params.id.replace(":", "") == "test"){
            return false;
          }
        } catch(err){
          console.log(err);
        }

        const response = await Benutzer.getSingleWithKonvKey(konvKey);

        if(response == false){ //&& this.$route.params.id.replace(":", "") != test){
          this.showEinsatzView = false;
          this.tryLocalAppLogin();
          return false;
        } else{
          this.showEinsatzView = true;
          return response;
        }
      },
      tryLocalAppLogin(){
        const router = useRouter();
        if(!this.showEinsatzView){
            window.location.href = '/';
        }
      },
      enterFullscreen(element) {
        if(element.requestFullscreen) {
          element.requestFullscreen();
        } else if(element.msRequestFullscreen) {      // for IE11 (remove June 15, 2022)
          element.msRequestFullscreen();
        } else if(element.webkitRequestFullscreen) {  // iOS Safari
          element.webkitRequestFullscreen();
        }
      },
      isBrowser(){
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Überprüfen auf gängige Browser-Strings
        if ((userAgent.includes("Chrome") || userAgent.includes("Safari") || userAgent.includes("Firefox") || userAgent.includes("Edge")) && typeof window.cordova == "undefined") {
            return true;  // Wahrscheinlich ein Browser
        } else {
            return false;  // Möglicherweise eine App
        }
      },
      requestFullscreen(){
        if(!this.fullscreen){
          if(this.isBrowser()){
            Swal.fire({
              title: "Anwendung im Vollbild starten",
              showDenyButton: true,
              confirmButtonText: "Ja",
              denyButtonText: `Nein`
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                this.enterFullscreen(document.documentElement)
                this.fullscreen = true;
              } else if (result.isDenied) {
                this.fullscreen = false;
              }
            });
          }
        } else{
          document.exitFullscreen();
          this.fullscreen = false;
        }
      },
      async createCertificate(){
        try {
          const response = await axios.get("https://"+ this.ip + ":5000/run-cert-update");
          console.log("Ergebnis:", response.data);
        } catch (error) {
          console.error("Fehler beim Starten des Scripts:", error);
        }
      },
      async getIP(){
        await axios.get("https://api.ipify.org")
        .then(res => {
            this.ip = res.data;
        })
        .catch(err => console.error(err));
      }
    },
    async created() {
      this.routeParams = this.$route.params.id;
      this.getAktiveKacheln();
      console.log(this.routeParams);
      await this.getBenutzerDefaults();
      await this.getIP();
    },
}
</script>

<style lang="scss" scoped>
.home {
  height: 90vh;
  width: 100vw;
  background-color: rgb(248, 248, 248);
  overflow:hidden;
  overflow-y: auto;
}

.flame{
    height: 4rem;
    display: block;
    position:fixed;
    right: 1rem;
    top: 1rem;
    z-index: 2;
}

.menu{
  width: 2.7rem;
  height: 2.7rem;
  border: solid rgb(236, 236, 236) 1px;
  background-color:white;
  border-radius: 50%;
  //border: none;
  //background-color: transparent;
  color: rgb(34, 34, 34);
  position: fixed;
  left: 2rem;
  top: 2rem;
  z-index: 50;
  //box-shadow: 0 4px 12px rgb(235, 235, 235);
}

.menu:hover{
  //transform: scale(1.05);
  cursor: pointer;
}

.menuActive{
  transform: rotateZ(-90deg);
  transition: transform 0.3s;
}

.menuDeactive{
  transform: rotateZ(0deg);
  transition: transform 0.3s;
}

h1{
  margin-top: 7rem;
  width: 90vw;
  margin-left: 5vw;
  margin-bottom: 3.5rem;
  font-size:x-large;
}

.einsatzdashboard{
  background-color: white;
  width: 90vw;
  margin-left: auto;
  margin-right: auto;
  margin-top: 6.5rem;
  height: auto;
  border: solid rgb(236, 236, 236) 1px;
  border-radius: 8px;
  cursor: default;

  .line1{
    padding-left: 0.9rem;
    padding-right: 0.9rem;
    display: flex;
    div{
      width: 70vw;

      .aktuellerEinsatz{
        text-align: left;
        font-size: large;
        margin-top: 3rem;
      }

      .einsatzText{
        text-align: left;
        font-size: small;
      }

      .feuerwehrmann{
        width: 90%;
        margin-top: 1.7rem;
      }
    }
  }

  .line2{
    padding-left: 0.9rem;
    padding-right: 0.9rem;
    margin-bottom: 0.9rem;

    .einsatzdashboardButton{
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      font-size: medium;
      padding-top: 0.6rem;
      padding-bottom: 0.6rem;
      padding-left: 1rem;
      padding-right: 1rem;
      border: solid rgb(236, 236, 236) 1px;
      border-radius: 8px;
      background-color: #C00000;
      color: white;
      text-align: left;
      display: flex;
      justify-content: space-between;
      cursor: pointer;
    }
  }
}

.einsatzdashboard:hover{
    transform: scale(1.005);
    box-shadow: 0.5px 0.5px rgb(201, 201, 201);
}

.Schnellkacheln{
  width: 90vw;
  margin: 0.8rem auto;
  display: flex;
  gap: 0.5rem;
}

.Sonstiges{
  width: 90vw;
  margin: 0.8rem auto;
  display: flex;
  gap: 0.5rem;

  .sonstigeCont{
    height: 100%;
    flex: 1;
    aspect-ratio: 5 / 3;
    background-color: white;
    border: 1px solid rgb(236, 236, 236);
    border-radius: 8px;
    display: flex;


    .sonstigeImageCont{
      width: 45%;
      display: flex;
      align-items: center;

      .sonstigeImage{
        width: 100%;
        object-fit: cover;
      }
    }

    .sonstigeTextCont{
      width: 55%;

      .sonstigeText{
        margin-top: 40%;
        font-size: medium;
        margin-right: 0.3rem;
      }
    }
  }

  .sonstigeCont:hover{
    transform: scale(1.01);
    cursor: pointer;
    box-shadow: 0.5px 0.5px rgb(201, 201, 201);
  }
}

.einsatzdashboardButtonResponsive{
  display: none;
  width: 100%;
  max-width: 30rem;
  margin-left: 0;
  font-size: medium;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border: solid rgb(236, 236, 236) 1px;
  border-radius: 8px;
  background-color: #C00000;
  color: white;
  text-align: left;
  display: none;
  justify-content: space-between;
  cursor: pointer;
  position: absolute;
  bottom: 1rem;
}


@media screen and (min-width: 400px){
  .einsatzdashboard{
    max-height: 35vh;
    position: relative;
    margin-top: 5.5rem;
  }

  .feuerwehrmann{
    height: 25vh !important;
    width: auto !important;
  }

  .einsatzdashboardButton{
    display:none !important;
  }

  .einsatzdashboardButtonResponsive{
    display: flex;
    font-size: x-large;
    margin-left: 3rem;
  }

  .aktuellerEinsatz{
    font-size: xx-large !important;
    margin-left: 3rem;
    margin-bottom: 0.8rem !important;
  }

  .einsatzText{
    font-size: x-large !important;
    margin-left: 3rem;
    margin-top: 0.5rem !important;
  }

  .Schnellkacheln{
    margin: 0.8rem auto;
    display: flex;
    gap: 0.5rem;
  }

  .sonstigeCont{
    aspect-ratio: unset !important;
    height: 13vh !important;
  }

  .sonstigeImageCont{
    width: 8rem !important;
    margin-left: 2rem;
  }

  .sonstigeTextCont{
    height: 100% !important;
    align-items: center !important;
    display: flex !important;
  }

  .sonstigeText{
    margin: 0 !important;
    margin-left: 2rem !important;
    display: inline !important;
    font-size: xx-large !important;
  }
}
</style>

<style lang="scss">
.slide-up-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.slide-up-enter-active {
  transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
  //transition: all 0.6s ease-out;
}

/* Stagger-Effekt (Verzögerung) */
.slide-up-enter-active:nth-child(1) {
  transition-delay: 0.1s;
}
.slide-up-enter-active:nth-child(2) {
  transition-delay: 0.1s;
}
.slide-up-enter-active:nth-child(3) {
  transition-delay: 0.1s;
}
.slide-up-enter-active:nth-child(4) {
  transition-delay: 0.1s;
}
</style>
  
